import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';

export class ReleasePhaseIcon extends Field {
  static subqueriesForModel() {
    return { releasePhase: ['color'] };
  }

  get title() {
    return `${terminology('Release phase')} icon`;
  }

  exampleContents(): FieldContentsData {
    return { icon: { name: 'fa-solid fa-timeline', color: '#B540BF' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.releasePhase) {
      return {
        icon: {
          name: 'fa-solid fa-timeline',
          color: record.releasePhase.colorObject.hex(),
        },
      };
    }

    return {};
  }
}
